import {  Button } from '@achieve/ascend'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import { rewriteAssetUrl } from 'utils/conversions/urls'

export const CardPressSection = ({ content }) => {
  const title = content?.fields?.titleText
  const description = content?.fields?.description?.json?.content?.[0]?.content[0]?.value
  const image = content?.fields?.image
  const downloadFile = rewriteAssetUrl(content?.fields?.downloadFile?.url)

  const downloadFileAuto = (url) => {
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.download = `${title}`
    link.dispatchEvent(new MouseEvent('click'))
  }

  return (
    <div className="w-full mb-[60px]">
      <div className="flex flex-col lg:flex-row w-full">
        <div className="flex flex-col lg:flex-row w-full lg:w-3/4">
          <div className="flex justify-center w-auto h-auto">
            <div>
              <MediaImageStandard
                className="rounded-[10px] object-cover"
                content={image}
                layout="fixed"
                width={279}
                height={156}
              />
            </div>
          </div>

          <div className="flex flex-col items-center lg:items-start mt-[60px] lg:mt-0 px-0 lg:pl-4">
            <Typography
              content={title}
              variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyLg' }}
              fontWeight="medium"
              styleOverride={{
                [BLOCKS.PARAGRAPH]: {
                  textAlign: 'center',
                },
              }}
            />
            <div className="mt-10 max-w-[279px] lg:max-w-[385px]">
              <Typography
                content={description}
                variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodySm' }}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center lg:items-end mt-[64px] lg:mt-0 w-full lg:w-1/4 lg:pl-[60px]">
          <Button
            color="primary"
            onClick={() => downloadFileAuto(downloadFile)}
            variant="contained"
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  )
}
